import { PrimeReactProvider } from 'primereact/api';

export const GuardianProvider = PrimeReactProvider;
